import { readingTime } from 'reading-time-estimator';

/**
 * Format ISO date string to readable format
 * @param {string} dateString - ISO date string (e.g., "2025-11-15")
 * @returns {string} Formatted date (e.g., "November 15, 2025")
 */
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

/**
 * Extract plain text from content array for read time calculation
 * @param {Array} contentArray - Array of content blocks
 * @returns {string} Plain text extracted from paragraphs
 */
export const extractTextFromContent = (contentArray) => {
  if (!contentArray || !Array.isArray(contentArray)) {
    return '';
  }

  return contentArray
    .filter((block) => block.type === 'paragraph' || block.type === 'heading')
    .map((block) => block.text)
    .join(' ');
};

/**
 * Calculate estimated read time using reading-time-estimator package
 * @param {Array} content - Array of content blocks
 * @returns {number} Estimated read time in minutes
 */
export const calculateReadTime = (content) => {
  const text = extractTextFromContent(content);
  const result = readingTime(text);
  return result.minutes || 1; // Minimum 1 minute
};

/**
 * Truncate text to specified length with ellipsis
 * @param {string} text - Text to truncate
 * @param {number} maxLength - Maximum length before truncation
 * @returns {string} Truncated text with ellipsis if needed
 */
export const truncateText = (text, maxLength) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return `${text.substr(0, maxLength)}...`;
};
